// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
// import classnames from "classnames";
import { OnOffSwitch } from "@lifepay/rc-ui-toolkit";
import { Lock } from "@lifepay/redux-subsystem-access";

// ABSOLUTE PATH IMPORTS
import { LOCK_KEYS } from "accessConfig";
import CardSmsSwitch from "data-containers/CardSmsSwitch";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./CardSmsControl.m.scss";

@themr("@lifepay/CardSmsControl", styles)
export default class CardSmsControl extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    oldPhone: PropTypes.string,
    cardId: PropTypes.string,
    smsPhone: PropTypes.string,
    smsStatus: PropTypes.number,
    onSuccess: PropTypes.func,
    updateQuery: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
    };
  }

  render() {
    const { theme, cardId, smsPhone, smsStatus, updateQuery } = this.props;
    const { loading } = this.state;
    return (
      <CardSmsSwitch cardId={cardId} action={!smsStatus ? "on" : "off"}>
        {({ mutate }) => {
          return (
            <Lock
              lockId={LOCK_KEYS.CARD_SMS_NOTIFICATIONS_SWITCH}
              type={"lock"}
              theme={{
                inner: theme["switch-inner"],
                content: theme["switch-content"],
              }}
            >
              <OnOffSwitch
                id={`bank_card_toggle_sms_${cardId}`}
                name="bank_card_toggle_sms"
                wait={loading}
                disabled={!smsPhone}
                checked={!!smsStatus}
                onChange={
                  !loading
                    ? () => {
                        this.setState({
                          loading: true,
                        });
                        mutate({
                          update: (proxy, response) => {
                            if (response && response.data) {
                              let newStatus = smsStatus;
                              if (
                                response.data.smsInfoOn &&
                                response.data.smsInfoOn.success
                              ) {
                                newStatus = 1;
                              }
                              if (
                                response.data.smsInfoOff &&
                                response.data.smsInfoOff.success
                              ) {
                                newStatus = 0;
                              }
                              updateQuery((previousResult) => {
                                this.setState({
                                  loading: false,
                                });
                                if (previousResult && previousResult.cards) {
                                  const newResults = JSON.parse(
                                    JSON.stringify(previousResult)
                                  );
                                  const cardIndex = newResults.cards.findIndex(
                                    (val) => val.cardId === cardId
                                  );
                                  newResults.cards[
                                    cardIndex
                                  ].smsStatus = newStatus;
                                  return newResults;
                                }
                                return previousResult;
                              });
                            }
                          },
                        }).catch((e) => {
                          this.setState({
                            loading: false,
                            error: e,
                          });
                        });
                      }
                    : undefined
                }
              />
            </Lock>
          );
        }}
      </CardSmsSwitch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/controls/CardSmsControl/CardSmsControl.js